<template>
  <div>
    <button class="PILL p-x-2:t btn-sm p-x-1:mo bd-transparent" @click.prevent="$emit('click')">
      <span class="TEXT">{{ label }}</span>
      <vk-icon name="close" class="m-l-1" :class="xClass" size="10"/>
    </button>
  </div>
</template>

<script>
export default {
  name: 'filter-pill',
  props: {
    label: {
      type: String,
      default: 'Hello test',
    },
    xClass: {
      type: String,
      default: 'c-red',
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .PILL {
    background-color: $color-gray30;
    border-radius: 15px;
    height: 30px !important;
    outline: none;
    &:hover {
      background-color: $color-gray20;
    }
    .TEXT {
      font-size: 14px;
    }
  }
</style>
